var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{ref:"plages",attrs:{"stripped":"","small":"","borderless":"","striped":"","fields":_vm.fields,"items":_vm.vplages},scopedSlots:_vm._u([{key:"cell(days)",fn:function(data){return _vm._l((_vm.getdays(data.value)),function(day){return _c('div',{key:day},[_vm._v(_vm._s(day))])})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }